module.exports = __webpack_public_path__ + "img/primary.9822306c.svg";